<template>
  <el-table-column
    prop="make"
    sortable
    label="Márka"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.make }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'make',
  };
</script>
